// // modules/components/reports/thabat/CombinedOverviewCharts.js
// import * as React from "react";
// import {
//     Box,
//     Card,
//     CardContent,
//     Grid,
//     Typography,
//     alpha,
//     useTheme
// } from "@mui/material";
// import {
//     PieChart,
//     ChartsTooltip,
//     PieArcLabel,
// } from "@mui/x-charts";

// const CombinedOverviewCharts = ({
//     offersData,
//     servicesData,
//     sourceTab, // 0 for crops, 1 for services
//     isNeed, // true for requests, false for offers
// }) => {
//     const theme = useTheme();

//     // Select the appropriate data based on sourceTab
//     const currentData = sourceTab === 0 ? offersData : servicesData;
//     const sourceType = sourceTab === 0 ? 'Crops' : 'Services';
    
//     // Filter data based on type (request/offer)
//     const filteredData = currentData.filter(item => {
//         if (sourceTab === 0) { // Crops
//             return isNeed ? item.offer_type === 'need' : item.offer_type === 'donate';
//         } else { // Services
//             return isNeed ? item.service_type === 'need' : item.service_type === 'donate';
//         }
//     });

//     console.log(`CombinedOverviewCharts - ${sourceType} ${isNeed ? 'Requests' : 'Offers'}:`, filteredData);

//     // Prepare category distribution data
//     const prepareCategoryDistribution = () => {
//         const categoryMap = new Map();
        
//         filteredData.forEach(item => {
//             // Get category name based on source
//             let categoryName = 'Uncategorized';
//             if (sourceTab === 0) { // Crops
//                 categoryName = item.sub_category?.name || item.subCategory?.name || 'Uncategorized';
//             } else { // Services
//                 categoryName = item.service?.name || 'Uncategorized';
//             }
            
//             const current = categoryMap.get(categoryName) || 0;
//             categoryMap.set(categoryName, current + 1);
//         });

//         return Array.from(categoryMap.entries())
//             .map(([name, count]) => ({
//                 name: name,
//                 label: name,
//                 value: count
//             }))
//             .sort((a, b) => b.value - a.value)
//             .slice(0, 10); // Limit to top 10 categories
//     };

//     // Prepare status distribution data
//     const prepareStatusDistribution = () => {
//         const statusMap = new Map();
        
//         filteredData.forEach(item => {
//             const status = item.status || 'unknown';
//             let statusLabel = status;
            
//             // Format status labels for better display
//             switch(status) {
//                 case 'active':
//                     statusLabel = 'Active';
//                     break;
//                 case 'donated':
//                 case 'sold':
//                     statusLabel = 'Completed';
//                     break;
//                 case 'pending':
//                     statusLabel = 'Pending';
//                     break;
//                 default:
//                     statusLabel = status.charAt(0).toUpperCase() + status.slice(1);
//             }
            
//             const current = statusMap.get(statusLabel) || 0;
//             statusMap.set(statusLabel, current + 1);
//         });

//         return Array.from(statusMap.entries()).map(([status, count]) => ({
//             status: status,
//             label: status,
//             count: count,
//             value: count
//         }));
//     };

//     // Prepare monthly trend data (optional - can be added if API provides it)
//     const prepareMonthlyData = () => {
//         // This would require date data from your items
//         // You can implement this if your API returns created_at dates
//         return [];
//     };

//     const categoryDistribution = prepareCategoryDistribution();
//     const statusDistribution = prepareStatusDistribution();
    
//     // Check if we have data to display
//     if (filteredData.length === 0) {
//         return (
//             <Box sx={{ p: 3, textAlign: 'center' }}>
//                 <Typography variant="body1" color="text.secondary">
//                     No {sourceType.toLowerCase()} {isNeed ? 'requests' : 'offers'} data available
//                 </Typography>
//             </Box>
//         );
//     }

//     return (
//         <Grid container spacing={3}>
//             {/* Category Distribution Chart */}
//             {categoryDistribution.length > 0 ? (
//                 <Grid item xs={12} md={6}>
//                     <Card
//                         sx={{
//                             background: alpha(theme.palette.background.paper, 0.8),
//                             backdropFilter: "blur(8px)",
//                             height: "100%",
//                         }}
//                     >
//                         <CardContent>
//                             <Typography variant="h6" gutterBottom fontWeight="bold">
//                                 {sourceType} {isNeed ? 'Request' : 'Offer'} Categories
//                             </Typography>
//                             <Box sx={{ height: 300 }}>
//                                 <PieChart
//                                     series={[
//                                         {
//                                             data: categoryDistribution.map((item, index) => ({
//                                                 id: item.name || `category-${index}`,
//                                                 label: item.name,
//                                                 value: item.value,
//                                             })),
//                                             innerRadius: 40,
//                                             outerRadius: 100,
//                                             paddingAngle: 2,
//                                             cornerRadius: 6,
//                                             highlightScope: { faded: "global", highlighted: "item" },
//                                             faded: {
//                                                 innerRadius: 30,
//                                                 additionalRadius: -30,
//                                                 color: "gray",
//                                             },
//                                             arcLabel: (item) => `${item.value}`,
//                                             arcLabelMinAngle: 20,
//                                         },
//                                     ]}
//                                     slotProps={{
//                                         legend: {
//                                             direction: "row",
//                                             position: { vertical: "bottom", horizontal: "middle" },
//                                             padding: 0,
//                                             labelStyle: {
//                                                 fontSize: 12,
//                                                 fill: theme.palette.text.primary,
//                                             },
//                                         },
//                                     }}
//                                 >
//                                     <ChartsTooltip />
//                                     <PieArcLabel />
//                                 </PieChart>
//                             </Box>
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             ) : (
//                 <Grid item xs={12} md={6}>
//                     <Card
//                         sx={{
//                             background: alpha(theme.palette.background.paper, 0.8),
//                             backdropFilter: "blur(8px)",
//                             height: "100%",
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                         }}
//                     >
//                         <CardContent>
//                             <Typography variant="body1" color="text.secondary">
//                                 No category distribution data available
//                             </Typography>
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             )}

//             {/* Status Distribution Chart */}
//             {statusDistribution.length > 0 ? (
//                 <Grid item xs={12} md={6}>
//                     <Card
//                         sx={{
//                             background: alpha(theme.palette.background.paper, 0.8),
//                             backdropFilter: "blur(8px)",
//                             height: "100%",
//                         }}
//                     >
//                         <CardContent>
//                             <Typography variant="h6" gutterBottom fontWeight="bold">
//                                 Status Distribution ({sourceType} {isNeed ? 'Requests' : 'Offers'})
//                             </Typography>
//                             <Box sx={{ height: 300 }}>
//                                 <PieChart
//                                     series={[
//                                         {
//                                             data: statusDistribution.map((item) => ({
//                                                 id: item.status,
//                                                 label: item.label,
//                                                 value: item.count,
//                                             })),
//                                             innerRadius: 40,
//                                             outerRadius: 100,
//                                             paddingAngle: 2,
//                                             cornerRadius: 6,
//                                             highlightScope: { faded: "global", highlighted: "item" },
//                                             faded: {
//                                                 innerRadius: 30,
//                                                 additionalRadius: -30,
//                                                 color: "gray",
//                                             },
//                                             arcLabel: (item) => `${item.value}`,
//                                             arcLabelMinAngle: 20,
//                                         },
//                                     ]}
//                                     slotProps={{
//                                         legend: {
//                                             direction: "row",
//                                             position: { vertical: "bottom", horizontal: "middle" },
//                                             padding: 0,
//                                             labelStyle: {
//                                                 fontSize: 12,
//                                                 fill: theme.palette.text.primary,
//                                             },
//                                         },
//                                     }}
//                                 >
//                                     <ChartsTooltip />
//                                     <PieArcLabel />
//                                 </PieChart>
//                             </Box>
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             ) : (
//                 <Grid item xs={12} md={6}>
//                     <Card
//                         sx={{
//                             background: alpha(theme.palette.background.paper, 0.8),
//                             backdropFilter: "blur(8px)",
//                             height: "100%",
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                         }}
//                     >
//                         <CardContent>
//                             <Typography variant="body1" color="text.secondary">
//                                 No status distribution data available
//                             </Typography>
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             )}
//         </Grid>
//     );
// };

// export default CombinedOverviewCharts;
import * as React from "react";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    alpha,
    useTheme
} from "@mui/material";
import {
    PieChart,
    ChartsTooltip,
    PieArcLabel,
} from "@mui/x-charts";

const CombinedOverviewCharts = ({
    typeDistribution,
    statusDistribution,
    contributionDistribution,
    sourceTab, // 0 for crops, 1 for services
    isNeed, // true for requests, false for offers
}) => {
    const theme = useTheme();
    const sourceType = sourceTab === 0 ? 'Crops' : 'Services';

    // Map backend typeDistribution to chart format
    const categoryDistribution = (typeDistribution || [])
        .map(item => ({
            name: item.name,
            label: item.name,
            value: parseInt(item.count) || 0
        }))
        .filter(item => item.value > 0)
        .sort((a, b) => b.value - a.value)
        .slice(0, 10); // Limit to top 10 categories

    // Map backend statusDistribution to chart format
    const statusDistributionData = (statusDistribution || [])
        .map(item => ({
            status: item.status,
            label: item.label || item.status,
            count: parseInt(item.count) || 0,
            value: parseInt(item.count) || 0
        }))
        .filter(item => item.value > 0);

    // Map backend contributionDistribution to chart format (10% vs 20% vs not specified)
    const contributionDistributionData = (contributionDistribution || [])
        .map(item => {
            const percentage = item.contribution_percentage;
            return {
                id: percentage === null || percentage === undefined ? 'none' : `${percentage}%`,
                label: percentage === null || percentage === undefined ? 'Not Specified' : `${percentage}%`,
                count: parseInt(item.count) || 0,
                value: parseInt(item.count) || 0
            };
        })
        .filter(item => item.value > 0);

    console.log(`CombinedOverviewCharts - ${sourceType} ${isNeed ? 'Requests' : 'Offers'}:`, {
        categoryDistribution,
        statusDistributionData,
        contributionDistributionData
    });

    // Check if we have data to display
    if (categoryDistribution.length === 0 && statusDistributionData.length === 0 && contributionDistributionData.length === 0) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                    No {sourceType.toLowerCase()} {isNeed ? 'requests' : 'offers'} data available
                </Typography>
            </Box>
        );
    }

    return (
        <Grid container spacing={3}>
            {/* Category Distribution Chart */}
            {categoryDistribution.length > 0 ? (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                        }}
                    >
                        <CardContent>
                            <Typography variant="h6" gutterBottom fontWeight="bold">
                                {sourceType} {isNeed ? 'Request' : 'Offer'} Categories
                            </Typography>
                            <Box sx={{ height: 300 }}>
                                <PieChart
                                    series={[
                                        {
                                            data: categoryDistribution.map((item, index) => ({
                                                id: item.name || `category-${index}`,
                                                label: item.name,
                                                value: item.value,
                                            })),
                                            innerRadius: 40,
                                            outerRadius: 100,
                                            paddingAngle: 2,
                                            cornerRadius: 6,
                                            highlightScope: { faded: "global", highlighted: "item" },
                                            faded: {
                                                innerRadius: 30,
                                                additionalRadius: -30,
                                                color: "gray",
                                            },
                                            arcLabel: (item) => `${item.value}`,
                                            arcLabelMinAngle: 20,
                                        },
                                    ]}
                                    slotProps={{
                                        legend: {
                                            direction: "row",
                                            position: { vertical: "bottom", horizontal: "middle" },
                                            padding: 0,
                                            labelStyle: {
                                                fontSize: 12,
                                                fill: theme.palette.text.primary,
                                            },
                                        },
                                    }}
                                >
                                    <ChartsTooltip />
                                    <PieArcLabel />
                                </PieChart>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            ) : (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CardContent>
                            <Typography variant="body1" color="text.secondary">
                                No category distribution data available
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )}

            {/* Status Distribution Chart */}
            {statusDistributionData.length > 0 ? (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                        }}
                    >
                        <CardContent>
                            <Typography variant="h6" gutterBottom fontWeight="bold">
                                Status Distribution ({sourceType} {isNeed ? 'Requests' : 'Offers'})
                            </Typography>
                            <Box sx={{ height: 300 }}>
                                <PieChart
                                    series={[
                                        {
                                            data: statusDistributionData.map((item) => ({
                                                id: item.status,
                                                label: item.label,
                                                value: item.count,
                                            })),
                                            innerRadius: 40,
                                            outerRadius: 100,
                                            paddingAngle: 2,
                                            cornerRadius: 6,
                                            highlightScope: { faded: "global", highlighted: "item" },
                                            faded: {
                                                innerRadius: 30,
                                                additionalRadius: -30,
                                                color: "gray",
                                            },
                                            arcLabel: (item) => `${item.value}`,
                                            arcLabelMinAngle: 20,
                                        },
                                    ]}
                                    slotProps={{
                                        legend: {
                                            direction: "row",
                                            position: { vertical: "bottom", horizontal: "middle" },
                                            padding: 0,
                                            labelStyle: {
                                                fontSize: 12,
                                                fill: theme.palette.text.primary,
                                            },
                                        },
                                    }}
                                >
                                    <ChartsTooltip />
                                    <PieArcLabel />
                                </PieChart>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            ) : (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CardContent>
                            <Typography variant="body1" color="text.secondary">
                                No status distribution data available
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )}

            {/* Contribution Percentage Distribution Chart (10% vs 20%) */}
            {contributionDistributionData.length > 0 ? (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                        }}
                    >
                        <CardContent>
                            <Typography variant="h6" gutterBottom fontWeight="bold">
                                Contribution Percentage ({sourceType} {isNeed ? 'Requests' : 'Offers'})
                            </Typography>
                            <Box sx={{ height: 300 }}>
                                <PieChart
                                    series={[
                                        {
                                            data: contributionDistributionData.map((item) => ({
                                                id: item.id,
                                                label: item.label,
                                                value: item.count,
                                            })),
                                            innerRadius: 40,
                                            outerRadius: 100,
                                            paddingAngle: 2,
                                            cornerRadius: 6,
                                            highlightScope: { faded: "global", highlighted: "item" },
                                            faded: {
                                                innerRadius: 30,
                                                additionalRadius: -30,
                                                color: "gray",
                                            },
                                            arcLabel: (item) => `${item.value}`,
                                            arcLabelMinAngle: 20,
                                        },
                                    ]}
                                    slotProps={{
                                        legend: {
                                            direction: "row",
                                            position: { vertical: "bottom", horizontal: "middle" },
                                            padding: 0,
                                            labelStyle: {
                                                fontSize: 12,
                                                fill: theme.palette.text.primary,
                                            },
                                        },
                                    }}
                                >
                                    <ChartsTooltip />
                                    <PieArcLabel />
                                </PieChart>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            ) : (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CardContent>
                            <Typography variant="body1" color="text.secondary">
                                No contribution percentage data available
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>
    );
};

export default CombinedOverviewCharts;